import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    ICandidate,
    ICenterState,
    IPaginatedData
} from './types'
import { blockUnblockCandidateThunk, CenterUserInactiveThunk, createCenterUsersThunk, getAllCandidatesThunk, getAllCenters, getAllCentreUsers, updateCenterUsersThunk, updateCentreDetails, updateCentreStatus, uploadsCentrePictureThunk } from './thunks';

const initialState: ICenterState = {
    initial: null,
    inProgress: false,
    allCenters: [],
    allCentreUsers: [],
    centrePicImage: '',
    updateResponse: '',
    totalCentreUserCount: 0,
    centrePicImagePath: '',
    allCandidates: null,
    allBlockedCandidates: null,
    allPreferredCandidates: null,
    centreuserInactiveProgress: false,
    error: '',
    clientNotificationSettings: null,
}

const centersSlice = createSlice({
    name: 'centers',
    initialState,
    reducers: {
        resetCentersErrorAction: (state) => {
            state.error = null
        },
        getAllCentersListAction: (state, action: PayloadAction<any>) => {
            state.allCenters = action.payload
        },
        setAllCentreUserListAction: (state, action: PayloadAction<any>) => {
            state.allCentreUsers = action.payload
        },
        setCentrePicAction: (state, action: PayloadAction<string>) => {
            state.centrePicImage = action.payload
        },
        setCentreProfilePicPathAction: (state, action: PayloadAction<string>) => {
            state.centrePicImagePath = action.payload
        },
        setCentreDetailsAction: (state, action: PayloadAction<any>) => {
            state.updateResponse = action.payload
        },
        setTotalCentreUsersCountAction: (state, action: PayloadAction<number>) => {
            state.totalCentreUserCount = action.payload
        },
        setAllCandidateListAction: (state, action: PayloadAction<IPaginatedData<ICandidate>>) => {
            state.allCandidates = action.payload
        },
        setAllBlockedCandidateListAction: (state, action: PayloadAction<IPaginatedData<ICandidate>>) => {
            state.allBlockedCandidates = action.payload
        },
        setAllPreferredCandidateListAction: (state, action: PayloadAction<IPaginatedData<ICandidate>>) => {
            state.allPreferredCandidates = action.payload
        },
        resetCentreProfilePicPathAction: (state) => {
            state.centrePicImagePath = '';
        },
         setCandidateNotificationSettings: (state, action: PayloadAction<any>) => {
          state.clientNotificationSettings = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(createCenterUsersThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(createCenterUsersThunk.fulfilled, (state, action) => {
            state.inProgress = false
            sessionStorage.clear()
        })
        builder.addCase(createCenterUsersThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        // update user details
        builder.addCase(updateCenterUsersThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(updateCenterUsersThunk.fulfilled, (state, action) => {
            state.inProgress = false
            sessionStorage.clear()
        })
        builder.addCase(updateCenterUsersThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        builder.addCase(getAllCenters.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(getAllCenters.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(getAllCenters.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        // getAll users related to centres
        builder.addCase(getAllCentreUsers.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(getAllCentreUsers.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(getAllCentreUsers.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        builder.addCase(uploadsCentrePictureThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(uploadsCentrePictureThunk.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(uploadsCentrePictureThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        // getAll users related to centres
        builder.addCase(updateCentreDetails.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(updateCentreDetails.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(updateCentreDetails.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        // Make in active the centre
        builder.addCase(updateCentreStatus.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(updateCentreStatus.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(updateCentreStatus.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        // Make in active the centre users
        builder.addCase(CenterUserInactiveThunk.pending, (state, action) => {
            state.centreuserInactiveProgress = true
            state.error = null
        })
        builder.addCase(CenterUserInactiveThunk.fulfilled, (state, action) => {
            state.centreuserInactiveProgress = false
        })
        builder.addCase(CenterUserInactiveThunk.rejected, (state, action) => {
            state.centreuserInactiveProgress = false
            state.error = action.payload
        })

        builder.addCase(getAllCandidatesThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(getAllCandidatesThunk.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(getAllCandidatesThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        builder.addCase(blockUnblockCandidateThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(blockUnblockCandidateThunk.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(blockUnblockCandidateThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })
    }
});

export const {
    resetCentersErrorAction,
    getAllCentersListAction,
    setAllCentreUserListAction,
    setCentrePicAction,
    setCentreProfilePicPathAction,
    setCentreDetailsAction,
    setTotalCentreUsersCountAction,
    setAllCandidateListAction,
    setAllBlockedCandidateListAction,
    setAllPreferredCandidateListAction,
    resetCentreProfilePicPathAction,
    setCandidateNotificationSettings
} = centersSlice.actions

export default centersSlice.reducer;